import React from 'react';
import QRCode from 'react-qr-code';

export interface RmQrLabelStickerProps {
  itemName: string;
  size: string;
  grade: string;
  lotNo: string;
  supplier: string;
  qrValue: string;
  /** 1-based package index */
  nopIndex: number;
  nopTotal: number;
}

/**
 * Physical RM identification sticker.
 * Layout: ITEM / SIZE / GRADE / LOT NO / SUPPLIER + QR + NOP counter.
 */
export function RmQrLabelSticker({
  itemName,
  size,
  grade,
  lotNo,
  supplier,
  qrValue,
  nopIndex,
  nopTotal,
}: RmQrLabelStickerProps) {
  const field = (label: string, value: string) => (
    <div className="rm-sticker-row">
      <span className="rm-sticker-label">{label}&nbsp;:-&nbsp;</span>
      <span className="rm-sticker-value">{value || '—'}</span>
    </div>
  );

  return (
    <div className="rm-sticker">
      <div className="rm-sticker-inner">
        <div className="rm-sticker-fields">
          {field('ITEM', itemName)}
          {field('SIZE', size)}
          {field('GRADE', grade)}
          {field('LOT NO', lotNo)}
          {field('SUPPLIER', supplier)}
        </div>
        <div className="rm-sticker-qr-wrap">
          <div className="rm-sticker-qr">
            <QRCode value={qrValue || ' '} size={118} level="M" />
          </div>
          <div className="rm-sticker-nop">
            {nopIndex}/{nopTotal}
          </div>
        </div>
      </div>
    </div>
  );
}
